import React, { FC, memo, useEffect, useState } from 'react'
import SingleInputHeader from './header/SingleInputHeader'
import SingleInputDetail from './detail/SingleInputDetail'
import { Dirary } from '../../types/dirary'
import classes from './SingleInputMain.module.scss'
import { useRecoilState } from 'recoil'
import { User } from '../../types'
import { userState } from '../../states/userState'
import { formatDate } from '../../utils/functions/formatting'
import {
  createDefaultDiary,
  createNonProductionDiary,
  nullADiaryList,
} from '../../utils/functions/createDefaultDiary'
import { useCheckSendable } from '../../hooks/singleInput/useCheckSendable'
import { calcWorkSchedule } from '../../utils/functions/workSchedule'
import { useCheckDiaryList } from '../../hooks/singleInput/useCheckDiaryList'
import { SHIFT_TYPE_NORMAL } from '../../utils/variables/shift'
import { postIdCounterState } from '../../states/postIdCounterState'
import { formatWorkerId } from '../../utils/variables/workerId'

//"HH:mm" → 通算分(夜勤2直対応: endMin初期値・計算用)
const timeToMin = (t: string) => {
  const [h, m] = t.split(':').map(Number)
  return h * 60 + m
}

export type workerInfoType = {
  workerId: string
  workerName: string
  departmentId: null | number
  departmentName: null | string
  place: null | string
  jobId: null | number
}
function createInitalWorkerInfo(
  workerFromOtherPage: string,
  workerIdFromRecoil: string,
  workerNameFromRecoil: string,
  callFrom: string
): workerInfoType {
  let workerId = ''
  let workerName = ''
  if (workerFromOtherPage !== '') {
    workerId = formatWorkerId(workerFromOtherPage)
    workerName = ''
  } else if (workerIdFromRecoil !== '') {
    workerId = formatWorkerId(workerIdFromRecoil)
    workerName = workerNameFromRecoil
  }
  if (callFrom === 'listByNew') {
    workerId = ''
    workerName = ''
  }

  return {
    workerId,
    workerName,
    departmentId: null,
    departmentName: null,
    place: null,
    jobId: null,
  }
}
type Props = {
  dateStringFromOtherPage?: string
  workerIdFromOtherPage?: string
  fromOtherPage?: boolean
  setIsShow?: React.Dispatch<React.SetStateAction<boolean>>
  callFrom?: string
  initialProductNo?: string
  initialProductBno?: string
}
const SingleInputMain: FC<Props> = memo((props) => {
  const {
    dateStringFromOtherPage = '',
    workerIdFromOtherPage = '',
    fromOtherPage = false,
    setIsShow,
    callFrom = '',
    initialProductNo = '',
    initialProductBno = '',
  } = props
  const { checkDiaryListSendable } = useCheckSendable()
  const [user, setUser] = useRecoilState<User>(userState)
  //読み込んだ日報リスト
  const [fetchDiaryList, setFetchDiaryList] = useState<Dirary[]>([])
  //作成した日報リスト
  const [diaryList, setDiaryList] = useState<Dirary[]>([])
  //追加・削除・更新日報リスト
  const { addDiaryList, deleteDiaryList, updateDiaryList } = useCheckDiaryList(
    diaryList,
    fetchDiaryList
  )
  //デフォルトの日報（単体）
  const [defaultDiary, setDefaultDiary] = useState<Dirary>(nullADiaryList)
  //デフォルトの製番（単体）
  const [defaultProductNo, setDefaultProductNo] = useState<string>(
    user.initialParameters.productNoForSingleInput!
  )
  //デフォルトの工場（単体）
  const [defaultFactoryNo, setDefaultFactoryNo] = useState<number>(
    user.initialParameters.factoryNoForSingleInput!
  )
  // //デフォルトの工事区分（単体）
  // const [defaultConstruction, setDefaultCondruction] = useState<number>(
  //   user.initialParameters.constructionForSingleInput!
  // );
  const [defaultProductBno, setDefaultProductBno] = useState<string>(
    user.initialParameters.productBnoForSingleInput!
  )
  //デフォルトの伝票番号（単体）
  const [defaultSlipNumber, setDefaultSlipNumber] = useState<string>(
    user.initialParameters.slipNumberForSingleInput!
  )
  //新規発行IDカウンタ
  const [postIdCounter, setPostIdCounter] = useRecoilState(postIdCounterState)

  //作業開始日
  const [workingDate, setWorkingDate] = useState({
    obj:
      dateStringFromOtherPage !== ''
        ? new Date(dateStringFromOtherPage)
        : new Date(),
    text: formatDate(
      dateStringFromOtherPage !== ''
        ? new Date(dateStringFromOtherPage)
        : new Date()
    ),
  })

  const [workerInfo, setWorkerInfo] = useState<workerInfoType>(
    createInitalWorkerInfo(
      workerIdFromOtherPage,
      user.initialParameters.workerSingleForInput?.workerId ?? '',
      user.initialParameters.workerSingleForInput?.workerName ?? '',
      callFrom
    )
  )
  //作業開始・終了時刻
  const [fromTime, setFromTime] = useState('08:30')
  const [toTime, setToTime] = useState('08:30')

  //合計時間
  const [totalTime, setTotalTime] = useState({
    hour: 0,
    min: 0,
    text: '00時間00分',
  })
  //送信可否
  const [isSendable, setIsSendable] = useState(false)
  //勤務区分(0=通常 / 1=夜勤)。日単位。夜勤2直対応。
  const [shiftType, setShiftType] = useState<number>(SHIFT_TYPE_NORMAL)
  //当日終了の通算分(ヘッダーの終了時刻・翌時刻併記表示に使用)
  const [endMin, setEndMin] = useState<number>(timeToMin('08:30'))
  //チェーンが24時間を超えているか(送信可否判定用・F5-1)
  const [isOverMaxChain, setIsOverMaxChain] = useState<boolean>(false)
  useEffect(() => {
    if (fetchDiaryList.length > 0) {
      //取得した日報リストをセット
      // console.log("default fetch");
      setDiaryList(fetchDiaryList)
      //夜勤2直対応: バックエンドがフォールバック済のため startTimeText は常に値あり。
      setFromTime(fetchDiaryList[0].startTimeText)
      //保存値を復元(自動判定しない)。区分未保存の既存データは 0=通常。
      setShiftType(fetchDiaryList[0].shiftType)
      // setHasBreak(fetchDiaryList[0].isBreak);
    } else if (workerInfo.workerName !== '') {
      //取得する日報が存在しない場合
      const nonProductionDiary = createNonProductionDiary(
        workerInfo,
        workingDate.text,
        fromTime,
        toTime,
        totalTime,
        // hasBreak,
        defaultFactoryNo
      )
      const newDiary = { ...nonProductionDiary, id: postIdCounter }
      setPostIdCounter((preCounter) => preCounter - 1)
      setDiaryList([newDiary])
      // setDiaryList([]);
      setFromTime('08:30')
      setShiftType(SHIFT_TYPE_NORMAL) //新規(08:30始業)は通常勤務
      // setHasBreak(false);
    } else {
      setDiaryList([])
    }
  }, [
    fetchDiaryList,
    workerInfo.workerName,
    workingDate.text,
    // fromTime,
    // toTime,
    // totalTime,
    // defaultFactoryNo,
  ])
  useEffect(() => {
    //デフォルトをセット
    setDefaultDiary(
      // createDefaultDiary(
      //   workerInfo,
      //   workingDate.text,
      //   fromTime,
      //   toTime,
      //   totalTime,
      //   // hasBreak,
      //   defaultProductNo,
      //   defaultProductBno,
      //   defaultFactoryNo,
      //   // defaultConstruction,
      //   defaultSlipNumber
      // )
      createDefaultDiary(
        workerInfo,
        workingDate.text,
        fromTime,
        toTime,
        totalTime,
        initialProductNo, //productNo
        initialProductBno, //productBno
        defaultFactoryNo,
        '0000000', //slipNumber
        shiftType //夜勤2直対応: 現在のトグル状態を反映
      )
    )
  }, [
    workerInfo,
    fromTime,
    toTime,
    totalTime,
    // hasBreak,
    workingDate,
    defaultProductNo,
    defaultProductBno,
    defaultFactoryNo,
    // defaultConstruction,
    defaultSlipNumber,
    shiftType,
  ])
  useEffect(() => {
    setDefaultProductNo(user.initialParameters.productNoForSingleInput!)
    setDefaultProductBno(user.initialParameters.productBnoForSingleInput!)
  }, [
    user.initialParameters.productBnoForSingleInput,
    user.initialParameters.productNoForSingleInput,
  ])
  useEffect(() => {
    setDefaultFactoryNo(user.initialParameters.factoryNoForSingleInput!)
    // setDefaultCondruction(user.initialParameters.constructionForSingleInput!);
  }, [
    user.initialParameters.factoryNoForSingleInput,
    // user.initialParameters.constructionForSingleInput,
  ])
  useEffect(() => {
    setDefaultSlipNumber(user.initialParameters.slipNumberForSingleInput!)
  }, [user.initialParameters.slipNumberForSingleInput])
  useEffect(() => {
    if (diaryList.length === 0) {
      setTotalTime({
        hour: 0.17,
        min: 10,
        text: '00時間00分',
      })

      // setFromTime("08:30");
      setToTime(fromTime)
      setEndMin(timeToMin(fromTime))
      setIsOverMaxChain(false)
    } else {
      //夜勤2直対応: 新エンジンで合計・終了時刻・24h超えを算出
      const schedule = calcWorkSchedule(
        fromTime,
        diaryList.map((d) => ({
          minutes: d.workingTimeByMinute,
          isBreak: d.isBreak,
        })),
        shiftType
      )
      setTotalTime({
        hour: schedule.totalHour,
        min: schedule.totalMin,
        text: schedule.totalText,
      })
      setToTime(schedule.endClock)
      setEndMin(schedule.endMin)
      setIsOverMaxChain(schedule.isOverMaxChain)
    }
  }, [diaryList, fromTime, shiftType])
  useEffect(() => {
    const res = checkDiaryListSendable(
      totalTime,
      diaryList,
      deleteDiaryList,
      isOverMaxChain //夜勤2直対応: 24h超えで送信不可(コード3)
    )
    if (res === 0) {
      setIsSendable(true)
    } else {
      setIsSendable(false)
    }
  }, [totalTime, diaryList, deleteDiaryList, isOverMaxChain])
  // useEffect(() => {
  //   if (diaryList.some((diary) => diary.isBreak === true)) {
  //     setHasBreak(true);
  //   } else {
  //     setHasBreak(false);
  //   }
  //   console.log("DEBUG_DIARYLIST_CHANGE", diaryList);
  // }, [diaryList]);
  // useEffect(() => {
  //   console.log("fetchDiaryList", fetchDiaryList);
  // }, [fetchDiaryList]);
  //開始時刻が変更されたとき
  useEffect(() => {
    //夜勤2直対応: fromTime/shiftType 変更時にチェーン全体を即時再計算(§4.4)
    const schedule = calcWorkSchedule(
      fromTime,
      diaryList.map((d) => ({
        minutes: d.workingTimeByMinute,
        isBreak: d.isBreak,
      })),
      shiftType
    )
    const finalList = diaryList.map((diary: Dirary, i) => {
      return {
        ...diary,
        startTime: schedule.entries[i].startClock,
        endTime: schedule.entries[i].endClock,
        startTimeText: schedule.entries[i].startText,
        endTimeText: schedule.entries[i].endText,
        spansNextDay: schedule.entries[i].spansNextDay,
        shiftType: shiftType,
        totalWorkingTimeByHour: schedule.totalHour,
        totalWorkingTimeByMinute: schedule.totalMin,
      }
    })
    setDiaryList(finalList)
  }, [fromTime, shiftType])
  return (
    <div className={classes.rootContainer}>
      <SingleInputHeader
        setTotalTime={setTotalTime}
        totalTime={totalTime}
        setWorkerInfo={setWorkerInfo}
        workerInfo={workerInfo}
        workingDate={workingDate}
        setWorkingDate={setWorkingDate}
        fromTime={fromTime}
        toTime={toTime}
        setFromTime={setFromTime}
        setToTime={setToTime}
        setFetchDiaryList={setFetchDiaryList}
        diaryList={diaryList}
        setDiaryList={setDiaryList}
        setIsShow={setIsShow}
        fromOtherPage={fromOtherPage}
        shiftType={shiftType}
        setShiftType={setShiftType}
        hasExistingReports={fetchDiaryList.length > 0}
        endMin={endMin}
      />
      <SingleInputDetail
        defaultDiary={defaultDiary}
        diaryList={diaryList}
        deleteDiaryList={deleteDiaryList}
        addDiaryList={addDiaryList}
        updateDiaryList={updateDiaryList}
        setDiaryList={setDiaryList}
        totalTime={totalTime}
        setTotalTime={setTotalTime}
        isSendable={isSendable}
        setIsShow={setIsShow}
        fromOtherPage={fromOtherPage}
        callFrom={callFrom}
        fromTime={fromTime}
        shiftType={shiftType}
        isOverMaxChain={isOverMaxChain}
        postIdCounter={postIdCounter}
        setPostIdCounter={setPostIdCounter}
      />
    </div>
  )
})

export default SingleInputMain
